import "./global.scss";
import "./shared/common";
import "./shared/config";
import Vue from "./setup";
import App from "./App.vue";
import { init } from "./service";

init().then(() => {
  new Vue({
    render: h => h(App)
  }).$mount("#root");
});
